export default "__VITE_ASSET__8cb23ff9__"